// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"551":"support","997":"styleguide"}[chunkId] + "." + {"551":"c994fa4f","997":"9b93d9c3"}[chunkId] + ".chunk.css";
};